/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import 'normalize.css';
import React from 'react';
import GlobalDataProvider from './src/storage/GlobalDataProvider';

export const wrapRootElement = ({ element }) => {
    return <GlobalDataProvider>{element}</GlobalDataProvider>
}